import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const CyberTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={`${containerClass} bg-black text-cyan-400 font-mono`}>
       <div className="border border-cyan-500/30 m-6 h-[calc(100%-3rem)] relative p-8 shadow-[0_0_20px_rgba(34,211,238,0.1)] rounded-lg">
           {/* Glitch Decors */}
           <div className="absolute top-0 left-0 w-4 h-4 border-l-2 border-t-2 border-cyan-500"></div>
           <div className="absolute top-0 right-0 w-4 h-4 border-r-2 border-t-2 border-cyan-500"></div>
           <div className="absolute bottom-0 left-0 w-4 h-4 border-l-2 border-b-2 border-cyan-500"></div>
           <div className="absolute bottom-0 right-0 w-4 h-4 border-r-2 border-b-2 border-cyan-500"></div>

           {!hideHeader && (
             <>
               <div className="flex justify-between items-end border-b border-cyan-900/50 pb-8 mb-8">
                   <div>
                       <h1 className="text-5xl font-bold uppercase tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">{profile.name}</h1>
                       <p className="text-xs text-purple-400 mt-2">:: SYSTEM.CONNECT :: {profile.email}</p>
                   </div>
                   <div className="text-right">
                       <div className="bg-cyan-900/20 px-4 py-1 border border-cyan-500/50 text-cyan-300 text-xs font-bold mb-2 inline-block">
                           STATUS: SECURE
                       </div>
                       <h2 className="text-3xl font-bold text-white">{type}</h2>
                   </div>
               </div>

               <div className="grid grid-cols-2 gap-8 mb-12">
                   <div className="bg-cyan-900/10 p-6 border border-cyan-500/20">
                       <p className="text-[10px] text-cyan-600 uppercase mb-2">TARGET_ENTITY</p>
                       {client ? (
                           <>
                               <p className="text-xl font-bold text-white mb-1">{client.name}</p>
                               <p className="text-sm opacity-70">{client.company}</p>
                           </>
                       ) : <span className="opacity-50">NULL</span>}
                   </div>
                   <div className="space-y-2 text-right">
                       {metaData.map((m, i) => (
                           <div key={i} className="flex justify-end gap-4">
                               <span className="text-cyan-700 text-xs">{m.label}</span>
                               <span className="text-white font-bold">{m.value}</span>
                           </div>
                       ))}
                   </div>
               </div>
             </>
           )}

           <div className="flex-1 cyber-table">
               {children}
           </div>

           <div className="mt-auto border-t border-cyan-900/50 pt-4 flex justify-between items-center text-xs text-cyan-700">
               <div>{footerNote}</div>
               <div className="animate-pulse">_END_OF_LINE</div>
           </div>
       </div>
    </div>
  );
};

export default CyberTemplate;